import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import logo from '../../Assets/logo/skilletix.png';
import Breadcrumb from '../Breadcrumb';

const ForgetPassword = () => {
  const [identifier, setIdentifier] = useState(''); 
  const [loading, setLoading] = useState(false); 
  const [message, setMessage] = useState(''); 
  const [error, setError] = useState('');

  // const validateInput = (input) => {
  //   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //   const mobileRegex = /^\+?[0-9]{10,15}$/;
  //   const usernameRegex = /^[a-zA-Z0-9._-]{3,}$/;

  //   if (emailRegex.test(input)) return 'email';
  //   if (mobileRegex.test(input)) return 'mobile';
  //   if (usernameRegex.test(input)) return 'username';
  //   return null;
  // };

  const validateIdentifier = (input) => {
    const trimmedInput = input.trim();
    if (trimmedInput.includes('@')) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(trimmedInput) ? 'email' : 'invalidEmail';
    }
    else if (/^[0-9]+$/.test(trimmedInput)) {
      return trimmedInput.length === 10 ? 'mobile' : 'invalidMobile';
    }
    else {
      const usernameRegex = /^(?=.*[A-Za-z])[A-Za-z0-9._-]{3,}$/;
      return usernameRegex.test(trimmedInput) ? 'username' : 'invalidUsername';
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault(); 
    setLoading(true);
    setMessage('');
    setError('');

    if (!identifier) {
      setError('Please enter your Email, Mobile Number, or Username.');
      setLoading(false);
      return;
    }

    // const inputType = validateInput(identifier);
    // if (!inputType) {
    //   setError('Invalid format. Please enter a valid Email, Mobile Number, or Username.');
    //   setLoading(false);
    //   return;
    // }
    const validationResult = validateIdentifier(identifier);
    if (validationResult === 'invalidEmail') {
      setError('Invalid email. Please enter a valid email address.');
      setLoading(false);
      return;
    } else if (validationResult === 'invalidMobile') {
      setError('Invalid mobile number. Please enter a valid 10-digit mobile number.');
      setLoading(false);
      return;
    } else if (validationResult === 'invalidUsername') {
      setError('Invalid username. Username must be at least 3 characters long and include at least one letter.');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}users/forget-password`,
        { identifier}
      );

      if (response.data && response.data.success) {
        setMessage(response.data.msg || 'Password reset link has been sent.');
      } else {
        setError(response.data.msg || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      if (err.response) {
        const status = err.response.status;
        if (status === 404) {
          // For 404 errors, override the server message with our custom messages.
          if (validationResult === 'email') {
            setError('Email not found. Please check and try again.');
          } else if (validationResult === 'mobile') {
            setError('Mobile number not found. Please check and try again.');
          } else {
            setError('Username not found. Please check and try again.');
          }
        } else if (status === 400) {
          setError(err.response.data?.msg || 'Bad Request. Please check your input.');
        } else {
          setError(err.response.data?.msg || 'An error occurred. Please try again later.');
        }
      } else if (err.request) {
        setError('Network error. The server may be down. Please check your connection.');
      } else {
        setError('An error occurred. Please try again later.');
      }
    }
    finally {
      setLoading(false);
    }
  };

  return (
    <main className="main mt-0">
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Forgot Password</h2>
          <ul className="breadcrumb-menu">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Forgot Password</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"
          className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Forgot Password"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Forgot Password", active: true }
        ]}
      />
      <div className="login-area py-120">
        <div className="container">
          <div className="col-md-5 mx-auto">
            <div className="login-form">
              <div className="login-header">
                <img
                loading="lazy"
                role="presentation"
                decoding="async"
                fetchpriority="high" 
                src={logo} alt="Logo" />
                <p>Reset your account password</p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Email, Mobile Number, or Username</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your Email, Mobile Number, or Username"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    required 
                  />
                </div>
                {error && (
                  <div className="alert alert-danger mt-2 text-center" role="alert">
                    {error}
                  </div>
                )}
                {message && (
                  <div className="alert alert-success mt-2 text-center" role="alert">
                    {message}
                  </div>
                )}
                <div className="d-flex align-items-center mt-3">
                  <button type="submit" className="theme-btn" disabled={loading}>
                    {loading ? (
                      <span>Sending...</span>
                    ) : (
                      <>
                        <i className="far fa-key" /> Send Reset Link
                      </>
                    )}
                  </button>
                </div>
              </form>
    
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ForgetPassword;
